import {useSortable} from "@dnd-kit/sortable"
import {CSS} from "@dnd-kit/utilities";
export const ReorderingRowWrapper = ({id, children}) => {
    const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id: String(id)});
    const style = {
		transition,
		transform: CSS.Transform.toString(transform)
	}

    return (
        <tr style={style} ref={setNodeRef} {...attributes} {...listeners}>{children}</tr>
    )
}